import baseConformsTo from './_baseConformsTo.js';
import keys from './keys.js';

/**
 * The base implementation of `_.conforms` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property predicates to conform to.
 * @returns {Function} Returns the new spec function.
 */
function baseConforms(source) {
  var props = keys(source);
  return function(object) {
    return baseConformsTo(object, source, props);
  };
}

export default baseConforms;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseConforms.js
// module id = 2077
// module chunks = 41